import React, { Component } from 'react';



export default class SelectableFieldsModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isSubscribedUser: false,
            fieldsChanged: false
        }
    }

    componentDidMount = () => {
        this.prepSelectableFields();
    }

    componentWillReceiveProps(nextProps) {
        const oldProps = this.state.isSubscribedUser;
        if (oldProps !== nextProps.isSubscribedUser) {
            this.setState({ isSubscribedUser: nextProps.isSubscribedUser }, 
                () => this.prepSelectableFields()
            );
        }
    }

    prepSelectableFields = () => {
        const { isSubscribedUser } = this.state;
        const { selectableFields, setState, user } = this.props;

        selectableFields.map((field) => {
            // a page that keeps the columns the user chose (keepSelection) is not put back to its default ones when the window opens again
            const isKept = this.props.keepSelection && field.checked !== undefined;

            if (!isKept) {
                field.checked = !!field.default;
            }

            // default field
            if (field.default) {
                field.allowAccess = true;
            }
            // free field
            else if (field.freeAccess) {
                field.allowAccess = true;
            } 
            // paid field with special access
            else if (!field.freeAccess && field.specialAccess) {
                if (user.roles.includes(field.specialAccess)) {
                    field.allowAccess = true;
                } else {
                    field.allowAccess = false;
                }
            } 
            // paid field and user subscribed
            else if (!field.freeAccess && isSubscribedUser) {
                field.allowAccess = true;
            } 
            // paid field and user not subscribed
            else {
                field.allowAccess = false;
            }
        })
        setState({ selectableFields });
    }

    handleSelectField = (index) => {
        const { selectableFields, setState } = this.props;
        const thisField = selectableFields[index];
        if (thisField.allowAccess) {
            selectableFields[index].checked = !thisField.checked;
            setState({ selectableFields });

            // set fieldsChanged: true if a field was added
            // not if it was removed/unchecked
            if (selectableFields[index].checked) {
                this.setState({ fieldsChanged: true });
            }
        }
    }

    // avoid calling API if fields haven't changed
    handleUpdateResults = () => {
        const { fieldsChanged } = this.state;

        const closeButtonForSelectModal = document.getElementById('closeButtonForSelectModal');
        if (closeButtonForSelectModal) {
            closeButtonForSelectModal.click();
        }

        if (fieldsChanged) {
            this.props.updateResults();
            this.setState({ fieldsChanged: false });
        }
    }

    render() {

        const { isSubscribedUser, selectableFields } = this.props;

        return (
            <div className="modal fade pr-0" id="selectFieldsModal" tabIndex="-1" role="dialog" aria-labelledby="selectFieldsModal-label" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">

                        {/* modal header */}
                        <div className="modal-header">
                            <h5 className="modal-title" id="selectFieldsModal-label">
                                Add Columns
                            </h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" id="closeButtonForSelectModal">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        {/* modal body */}
                        <div className="modal-body selectable-fields">
                            {selectableFields.map((field, index) => {
                                return (
                                    <div className="custom-control custom-checkbox" key={index}>
                                        <input id={"select" + index} type="checkbox" className="custom-control-input" disabled={!field.allowAccess} checked={field.checked ?? false} onChange={() => this.handleSelectField(index)} />
                                        <label htmlFor={"select" + index} className="custom-control-label">
                                            {field.fieldName}
                                        </label>
                                    </div>
                                )
                            })}
                        </div>

                        {/* modal footer */}
                        <div className="modal-footer">
                            {!isSubscribedUser &&
                                <a type="button" className="btn btn-secondary btn-md" href="/pricing" target="_blank" rel="noopener noreferrer">
                                    Unlock All Columns
                                </a>
                            }
                            <button type="button" className="btn btn-main btn-md" onClick={() => this.handleUpdateResults()}>
                                Update
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}